// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2bd5aa3e","977":"0bae1923"}[chunkId] + ".chunk.js";
};